import { useState } from 'react';

export default function useToken() {

  const getToken = () => {
    // const tokenString = sessionStorage.getItem('token');
    const tokenString = localStorage.getItem('token');
    //if (tokenString == null) tokenString = '0'
    const userToken = tokenString ? tokenString : undefined;
    //console.log(userToken)
    return userToken;
  };

  const saveToken = userToken => {
    localStorage.setItem('token', userToken);
    //sessionStorage.setItem('token', userToken);
    setToken(userToken);
  };
  const removeToken = () => {
    localStorage.removeItem('token')
  }
  const setLastLogin = () => {
    localStorage.setItem("lastLogin", Date.now())
  }


  const setRefresh = r => {
    localStorage.setItem("refresh", r);
    setRefreshState(r)
  }
  const getRefresh = () => {
    const r = localStorage.getItem("refresh") === "true"
    return r
  }
  const [refreshState, setRefreshState] = useState(getRefresh());
  const [token, setToken] = useState(getToken());
  return {
    setToken: saveToken,
    setLastLogin: setLastLogin,
    removeToken,
    token,
    refresh: refreshState,
    setRefresh
  }
}